import React from "react";
import { Box, Typography } from "@mui/material";
import { useSystemsContext } from "../../context/SystemsContext"; // 1. Import the context hook
import SystemSettingsForm from "./forms/SystemSettingsForm";

// 2. Remove all props, the component is now self-sufficient
const SystemDetails: React.FC = () => {
  // 3. Get the form data directly from the context for the title
  const { formData } = useSystemsContext();

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {/* Use the commonName from the context's formData */}
        {formData?.commonName || "System Details"}
      </Typography>

      <Typography variant="h6" sx={{ mb: 2, color: "text.secondary" }}>
        System Info
      </Typography>

      {/* 4. SystemSettingsForm is now self-sufficient and needs no props! */}
      <SystemSettingsForm />
    </Box>
  );
};

export default SystemDetails;